import { createContext, useContext } from 'react';

export const ZgGraphContext = createContext({
  client: null,
});

/**
 * @returns {import('@apollo/client').ApolloClient}
 */
export function useZgGraphqlApolloClient() {
  const { client } = useContext(ZgGraphContext);
  return client;
}
